import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Dashboard1Component } from "./dashboard1/dashboard1.component";
import { Dashboard2Component } from "./dashboard2/dashboard2.component";
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';
import { LatestDashboardComponent } from './latest-dashboard/latest-dashboard.component';

const routes: Routes = [
      
 
      {
        path: '',
        component: LatestDashboardComponent,
          canActivate: [PermissionGuard],
          data: { title: 'Dashboard',  roles: ['admin','Managment','Sales','Engineering','HR','Training Moderator','Teacher','Operation','Finance'] } 
      },
      {
        path: 'fees',
        component: Dashboard2Component,
        canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment','Finance'] } 
      },
     
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule { }
